import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import { ANDROID_PLATFORM } from '../../constants';
import { formatPurchaseEnforcementDate } from '../appCardUtils';
import { Field, HelpLabel, SwitchLine } from '../controls';
import css from '../AppCard.css';
import { sitePropType } from './propTypes';

const FraudControls = ({ platformFamilyName, purchaseEnforcementHasDate, readOnly, site, onSitePatch }) => (
    <div className={css.androidFraudRow}>
        {platformFamilyName === ANDROID_PLATFORM ? (
            <div className={css.androidLicenseField}>
                <div className={css.formFieldLabel}>
                    <Translate id="STATIC.PAGES.APPS_CONFIGURATION.ANDROID_INSTALL_VALIDATION_KEY" />
                </div>
                {!site.id || (site.sdk_integrated && site.android_install_validation_supported) ? (
                    <>
                        <Field
                            className={css.androidLicenseInput}
                            label={
                                <span className={css.visuallyHidden}>
                                    <Translate id="STATIC.PAGES.APPS_CONFIGURATION.ANDROID_INSTALL_VALIDATION_KEY" />
                                </span>
                            }
                            value={site.android_install_validation_key}
                            placeholder="(optional)"
                            disabled={readOnly}
                            onChange={value => onSitePatch({ android_install_validation_key: value })}
                        />
                        <a
                            href="https://support.singular.net/hc/en-us/articles/360031892592"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Where to find the key?
                        </a>
                    </>
                ) : null}
                {site.id && !site.sdk_integrated ? (
                    <div className={css.inlineError}>Must be Integrated with the Singular SDK</div>
                ) : null}
                {site.id && site.sdk_integrated && !site.android_install_validation_supported ? (
                    <div className={css.inlineError}>Must have SDK version 7.4.1 or higher</div>
                ) : null}
            </div>
        ) : null}
        <div className={css.androidRejectIapField}>
            <HelpLabel
                id="STATIC.PAGES.APPS_CONFIGURATION.ANDROID_PURCHASE_ENFORCEMENT_DATE"
                tooltip="STATIC.PAGES.APPS_CONFIGURATION.ANDROID_PURCHASE_ENFORCEMENT_DATE_TOOLTIP"
            />
            <SwitchLine
                checked={purchaseEnforcementHasDate}
                disabled={readOnly}
                label={
                    purchaseEnforcementHasDate ? (
                        <>
                            <Translate id="STATIC.PAGES.APPS_CONFIGURATION.ANDROID_PURCHASE_ENFORCEMENT_DATE_ENABLED" />
                            {formatPurchaseEnforcementDate(site.iap_enforcement_date)}
                        </>
                    ) : (
                        <Translate id="STATIC.PAGES.APPS_CONFIGURATION.ANDROID_PURCHASE_ENFORCEMENT_DATE_DISABLED" />
                    )
                }
                onChange={value => onSitePatch({ iap_enforcement_enabled: value })}
            />
        </div>
    </div>
);

FraudControls.propTypes = {
    onSitePatch: PropTypes.func.isRequired,
    platformFamilyName: PropTypes.string.isRequired,
    purchaseEnforcementHasDate: PropTypes.bool.isRequired,
    readOnly: PropTypes.bool.isRequired,
    site: sitePropType.isRequired,
};

export default FraudControls;
